<template>
    <Breadcrumbs main="Bonus Ui" title="Toasts" />
    <div class="container-fluid">
        <div class="row">
            <basicToasts />
            <iconToasts />
            <positionToasts />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/basicToasts.vue"))
const iconToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/iconToasts.vue"))
const positionToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/positionToasts.vue"))
</script>